import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const types = Object.freeze([
  {
    id: '1',
    value: "Documento d'identificazione del soggetto",
  },
  {
    id: '2',
    value: 'Modulo di domanda completo',
  },
  {
    id: '3',
    value: 'Dichiarazione del soggetto',
  },
  {
    id: '99',
    value: "Stato non censito nell'elenco",
  },
]);

interface ListTypeDocumentProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListTypeDocumentComponent = ({
  disabled,
  onChange,
  value,
  error,
}: ListTypeDocumentProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="type-label">Tipo documento *</InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type"
        name="type"
        value={value}
        label="Tipo documento *"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {types.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeDocumentComponent.displayName = 'List Type Document';

const ListTypeDocument = memo(ListTypeDocumentComponent);

export default ListTypeDocument as typeof ListTypeDocumentComponent;
